<template>
  <div class="user-detail">
    <el-page-header @back="goBack" content="用户详情" class="page-header" />

    <div v-if="userInfo" class="detail-container">
      <!-- 基本信息 -->
      <div class="detail-section">
        <div class="section-title">基本信息</div>
        <div class="detail-table">
          <div class="detail-row">
            <div class="detail-label">用户ID</div>
            <div class="detail-value">{{ userInfo.id }}</div>
          </div>
          <div class="detail-row">
            <div class="detail-label">昵称</div>
            <div class="detail-value">{{ userInfo.user_name || '-' }}</div>
          </div>
          <div class="detail-row">
            <div class="detail-label">手机号</div>
            <div class="detail-value">{{ userInfo.mobile || '-' }}</div>
          </div>
          <div class="detail-row">
            <div class="detail-label">头像</div>
            <div class="detail-value">
              <el-avatar v-if="userInfo.avatar" :src="userInfo.avatar" :size="60" />
              <el-avatar v-else icon="el-icon-user-solid" :size="60" />
            </div>
          </div>
          <div class="detail-row">
            <div class="detail-label">积分</div>
            <div class="detail-value">
              <span style="color: #f56c6c; font-weight: bold; font-size: 18px;">
                {{ userInfo.points || 0 }}
              </span>
            </div>
          </div>
          <div class="detail-row">
            <div class="detail-label">状态</div>
            <div class="detail-value">
              <el-tag :type="userInfo.status === 1 ? 'success' : 'danger'" size="medium">
                {{ userInfo.status === 1 ? '启用' : '禁用' }}
              </el-tag>
            </div>
          </div>
          <div class="detail-row">
            <div class="detail-label">注册时间</div>
            <div class="detail-value">{{ formatDate(userInfo.create_time) }}</div>
          </div>
          <div class="detail-row">
            <div class="detail-label">最后登录</div>
            <div class="detail-value">{{ formatDate(userInfo.last_login_time) }}</div>
          </div>
          <div class="detail-row">
            <div class="detail-label">邀请人ID</div>
            <div class="detail-value">{{ userInfo.inviter_id || '-' }}</div>
          </div>
        </div>
      </div>

      <!-- 统计信息 -->
      <div class="detail-section">
        <div class="section-title">统计信息</div>
        <div class="detail-table">
          <div class="detail-row">
            <div class="detail-label">优惠券数量</div>
            <div class="detail-value">
              <span style="color: #67c23a; font-weight: bold; font-size: 18px;">
                {{ couponCount }}
              </span>
              <span style="color: #909399; margin-left: 8px;">张</span>
            </div>
          </div>
          <div class="detail-row">
            <div class="detail-label">邀请人数</div>
            <div class="detail-value">
              <span style="color: #409eff; font-weight: bold; font-size: 18px;">
                {{ inviteCount }}
              </span>
              <span style="color: #909399; margin-left: 8px;">人</span>
            </div>
          </div>
        </div>
      </div>

      <!-- 邀请人信息 -->
      <div class="detail-section" v-if="inviter">
        <div class="section-title">邀请人信息</div>
        <div class="detail-table">
          <div class="detail-row">
            <div class="detail-label">邀请人ID</div>
            <div class="detail-value">{{ inviter.id }}</div>
          </div>
          <div class="detail-row">
            <div class="detail-label">邀请人昵称</div>
            <div class="detail-value">{{ inviter.user_name || '-' }}</div>
          </div>
          <div class="detail-row">
            <div class="detail-label">邀请人手机号</div>
            <div class="detail-value">{{ inviter.mobile || '-' }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getUserDetail } from '@/api/user'

export default {
  name: 'ClientUserDetail',
  data() {
    return {
      loading: false,
      userInfo: {},
      couponCount: 0,
      inviteCount: 0,
      inviter: null
    }
  },
  created() {
    this.getUserDetail()
  },
  methods: {
    async getUserDetail() {
      this.loading = true
      try {
        const userId = this.$route.query.id
        if (!userId) {
          this.$message.error('用户ID不能为空')
          this.goBack()
          return
        }

        const res = await getUserDetail(userId)
        if (res.code === 200) {
          this.userInfo = res.data.user || {}
          this.couponCount = res.data.coupon_count || 0
          this.inviteCount = res.data.invite_count || 0
          this.inviter = res.data.inviter || null
        } else {
          this.$message.error(res.msg || '获取用户详情失败')
        }
      } catch (error) {
        this.$message.error(error.message || '获取用户详情失败')
      } finally {
        this.loading = false
      }
    },
    goBack() {
      this.$router.back()
    },
    formatDate(dateStr) {
      if (!dateStr) return '-'
      // 如果是时间戳格式（数字），转换为秒级时间戳
      if (typeof dateStr === 'number') {
        const date = new Date(dateStr * 1000)
        return date.toLocaleString('zh-CN')
      }
      // 如果是字符串格式（如 "2026-01-01 21:09:33"），直接返回
      return dateStr
    }
  }
}
</script>

<style scoped>
.user-detail {
  padding: 20px;
}

.page-header {
  margin-bottom: 20px;
}

.detail-container {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.detail-section {
  background-color: #fff;
  border-radius: 4px;
  overflow: hidden;
}

.section-title {
  font-size: 16px;
  font-weight: 600;
  color: #303133;
  padding: 15px 20px;
  background-color: #FAFAFA;
  border-bottom: 1px solid #EBEEF5;
}

.detail-table {
  border: 1px solid #EBEEF5;
  border-radius: 4px;
  overflow: hidden;
  background-color: #fff;
}

.detail-row {
  display: flex;
  border-bottom: 1px solid #EBEEF5;
  min-height: 50px;
  align-items: center;
}

.detail-row:last-child {
  border-bottom: none;
}

.detail-label {
  font-weight: 500;
  color: #606266;
  width: 150px;
  text-align: right;
  padding: 15px 20px;
  background-color: #FAFAFA;
  border-right: 1px solid #EBEEF5;
  flex-shrink: 0;
  box-sizing: border-box;
}

.detail-value {
  color: #303133;
  word-break: break-word;
  padding: 15px 20px;
  flex: 1;
  box-sizing: border-box;
}
</style>
